export default __webpack_public_path__ + "static/beach-bora-bora-7bc0f61de3f7193446e6500c69ddcd7b.jpg";